module.exports = __webpack_public_path__ + "static/media/39.80bf7f5e.gif";